import React, { Component } from 'react';
import './../../Generic.css';


class MiddleCenterContainer extends Component {

    componentDidMount(props) {
    }

    render() {
        return (
            <div className="middle-center-container" style={this.props.style}>
                { this.props.children }
            </div>
        );
    }
}

export default MiddleCenterContainer;
